import {gql} from '@apollo/client';

export const CREATE_ORDER = gql`
    mutation createOnlyCashOrder ($data: OnlyCashOrderInput!, $token: String!, $session: String) {
        createOnlyCashOrder(data: $data, token: $token, session: $session) {
            data {
                id
                attributes {
                    payment {
                        data {
                            attributes {
                                orderUID
                                paymentURL
                            }
                        }
                    }
                }
            }
        }
    }
`

export const QUERY_ORDER = gql`
    query OnlyCashOrder ($UID: ID, $token: String!) {
        OnlyCashOrder(UID: $UID, token: $token) {
            status
        }
    }
`